import client from './client';
import type { ApiResponse, Notification, PaginatedResponse } from '../types';

interface RawNotification {
  id: number | string;
  title: string;
  message: string;
  type: string;
  channel?: string;
  module?: string;
  priority?: string;
  action_url?: string;
  action_label?: string;
  data?: Record<string, unknown> | null;
  read_at?: string | null;
  is_read?: boolean;
  created_at?: string;
}

const mapNotification = (n: RawNotification): Notification => ({
  id: String(n.id),
  type: ['info', 'success', 'warning', 'error'].includes(n.type)
    ? (n.type as Notification['type'])
    : 'info',
  title: n.title,
  message: n.message,
  module: n.module,
  channel: n.channel,
  priority: n.priority,
  actionUrl: n.action_url,
  actionLabel: n.action_label,
  data: n.data ?? undefined,
  isRead: Boolean(n.read_at ?? n.is_read),
  readAt: n.read_at ?? null,
  createdAt: n.created_at ?? new Date().toISOString(),
});

export const notificationsApi = {
  getNotifications: (params?: {
    page?: number;
    pageSize?: number;
    unread?: boolean;
    channel?: string;
  }) =>
    client
      .get<PaginatedResponse<RawNotification>>('/notifications', { params })
      .then((res) => ({
        ...res,
        data: {
          ...res.data,
          data: res.data.data.map(mapNotification),
        },
      })),

  getUnreadCount: () =>
    client
      .get<ApiResponse<{ unread_count: number }>>('/notifications/unread-count')
      .then((res) => res.data.data.unread_count),

  markAsRead: (id: string) =>
    client.post<ApiResponse<void>>(`/notifications/${id}/read`),

  markAllAsRead: () =>
    client.post<ApiResponse<void>>('/notifications/read-all'),

  registerDevice: (data: {
    token: string;
    platform?: string;
    app_version?: string;
    device_name?: string;
    device_model?: string;
  }) => client.post<ApiResponse<unknown>>('/notifications/devices', data),

  removeDevice: (id: string) =>
    client.delete<ApiResponse<void>>(`/notifications/devices/${id}`),
};
